/**
 * ===============================================================
 * ARQUIVO DE EDIÇÃO MANUAL RÁPIDA (SEM PRECISAR MEXER EM COMPONENTES)
 * ===============================================================
 *
 * Como usar:
 * 1) Para adicionar IMAGENS dinâmicas: coloque os arquivos em `public/images/pedidos-de-doces`, `public/images/cardapio-de-pascoa` e `public/images/novidades`.
 * 2) O site lê essas pastas automaticamente e cria cards/carrossel sem mexer nos componentes.
 * 3) Use `productsCatalog` e `updatesCatalog` como OVERRIDES (texto, preço, descrição, etc.) para cada imagem.
 * 4) Para remover um item da interface, basta remover a imagem correspondente da pasta.
 *
 * Regras simples:
 * - `id` deve ser único (sem espaços, use hífen).
 * - `price` deve ser número (ex.: 59.9).
 * - As imagens precisam existir na pasta /public.
 */

export const productsCatalog = [
  {
    id: 'brigadeiro-tradicional-50-cacau',
    name: 'Brigadeiro tradicional - 50% cacau',
    shortDescription: '15g • R$ 97,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 97,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-tradicional-50-cacau.jpeg',
  },
  {
    id: 'beijinho-tradicional',
    name: 'Beijinho',
    shortDescription: '15g • R$ 97,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 97,
    image: '/images/pedidos-de-doces/doces-tradicionais/beijinho.jpeg',
  },
  {
    id: 'brigadeiro-de-ninho-tradicional',
    name: 'Brigadeiro de ninho',
    shortDescription: '15g • A partir de R$ 97,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 97,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-ninho.jpeg',
  },
  {
    id: 'brigadeiro-de-pacoca-tradicional',
    name: 'Brigadeiro de paçoca',
    shortDescription: '15g • R$ 110,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 110,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-pacoca.jpeg',
  },
  {
    id: 'brigadeiro-de-morango-tradicional',
    name: 'Brigadeiro de morango',
    shortDescription: '15g • R$ 97,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 97,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-morango.jpeg',
  },
  {
    id: 'brigadeiro-de-ferreiro-tradicional',
    name: 'Brigadeiro Ferrero',
    shortDescription: '15g • R$ 125,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 125,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-ferreiro.jpeg',
  },
  {
    id: 'brigadeiro-de-prestigio-tradicional',
    name: 'Brigadeiro de prestígio',
    shortDescription: '15g • R$ 97,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 97,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-prestigio.jpeg',
  },
  {
    id: 'brigadeiro-casadinho-tradicional',
    name: 'Brigadeiro casadinho',
    shortDescription: '15g • R$ 97,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 97,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-casadinho.jpeg',
  },
  {
    id: 'brigadeiro-de-confete-tradicional',
    name: 'Brigadeiro de confete',
    shortDescription: '15g • R$ 130,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 130,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-confete.jpeg',
  },
  {
    id: 'brigadeiro-de-ninho-com-uva-tradicional',
    name: 'Brigadeiro de ninho com uva',
    shortDescription: '15g • R$ 130,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 130,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-ninho-com-uva.jpeg',
  },
  {
    id: 'brigadeiro-de-ninho-com-chocolate-tradicional',
    name: 'Brigadeiro de ninho com chocolate',
    shortDescription: '15g • R$ 120,00 • 100 unidades',
    details: 'Pedidos a partir de 50 unidades com alteração nos valores.',
    weight: '15g',
    price: 120,
    image: '/images/pedidos-de-doces/doces-tradicionais/brigadeiro-de-ninho-com-chocolate.jpeg',
  },
  {
    id: 'brigadeiro-fino-50-cacau',
    name: 'Brigadeiro - 50% cacau',
    shortDescription: '15g • R$ 180,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 180,
    image: '/images/pedidos-de-doces/doces-finos/brigadeiro-50-cacau.jpeg',
  },
  {
    id: 'brigadeiro-de-ninho-nutela-fino',
    name: 'Brigadeiro de ninho com Nutella',
    shortDescription: '15g • R$ 199,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 199,
    image: '/images/pedidos-de-doces/doces-finos/ninho-com-nutela.jpeg',
  },
  {
    id: 'brigadeiro-branco-fino',
    name: 'Brigadeiro branco',
    shortDescription: '15g • R$ 180,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 180,
    image: '/images/pedidos-de-doces/doces-finos/brigadeiro-branco.jpeg',
  },
  {
    id: 'brigadeiro-de-morango-com-roseta-fino',
    name: 'Brigadeiro de morango com roseta',
    shortDescription: '15g • R$ 150,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 150,
    image: '/images/pedidos-de-doces/doces-finos/brigadeiro-de-morango-com-roseta.jpeg',
  },
  {
    id: 'bombons-de-chocolate-com-riscos-fino',
    name: 'Bombons de chocolate com riscos',
    shortDescription: '15g • R$ 160,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 160,
    image: '/images/pedidos-de-doces/doces-finos/bonbons-de-chocolate-com-riscos.jpeg',
  },
  {
    id: 'camafeu-de-nozes-fino',
    name: 'Camafeu de nozes',
    shortDescription: '15g • R$ 360,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 360,
    image: '/images/pedidos-de-doces/doces-finos/camafeu-de-nozes.jpeg',
  },
  {
    id: 'coracao-de-brilho-fino',
    name: 'Coração de brilho',
    shortDescription: '15g • R$ 160,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 160,
    image: '/images/pedidos-de-doces/doces-finos/coracao-de-brilho.jpeg',
  },
  {
    id: 'trufa-flor-fino',
    name: 'Trufa flor',
    shortDescription: '15g • R$ 160,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 160,
    image: '/images/pedidos-de-doces/doces-finos/trufa-flor.jpeg',
  },
  {
    id: 'conchinhas-fino',
    name: 'Conchinhas',
    shortDescription: '15g • R$ 180,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 180,
    image: '/images/pedidos-de-doces/doces-finos/conchinhas.jpeg',
  },
  {
    id: 'fino-casquinha-de-chocolate-fino',
    name: 'Fino casquinha de chocolate (uva/morango/maracujá/limão)',
    shortDescription: '15g • R$ 155,00 • 100 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 155,
    image:
      '/images/pedidos-de-doces/doces-finos/fino-casquinha-de-chocolate-maracuja-morango-limao-uva.jpeg',
  },
  {
    id: 'fino-de-cereja',
    name: 'Fino de cereja',
    shortDescription: '15g • R$ 96,00 • 20 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 96,
    image: '/images/pedidos-de-doces/doces-finos/fino-de-cereja.jpeg',
  },
  {
    id: 'fino-geleia-de-frutas-vermelhas',
    name: 'Fino geleia de frutas vermelhas',
    shortDescription: '15g • R$ 96,00 • 20 unidades',
    details: 'Pedidos a partir de 20/50 unidades com alteração nos valores.',
    weight: '15g',
    price: 96,
    image: '/images/pedidos-de-doces/doces-finos/fino-geleia-de-frutas-vermelhas.jpeg',
  },
  {
    id: 'ninho-com-uva-pascoa',
    name: 'Ninho com uva',
    shortDescription: 'Ovo de Páscoa de ninho com recheio de uva.',
    details: 'Peso: 250g • Valor: R$ 75,00.',
    weight: '250g',
    price: 75,
    image: '/images/cardapio-de-pascoa/ninho-com-uva.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'ninho-com-nutela-pascoa',
    name: 'Ninho com Nutella',
    shortDescription: 'Ovo de Páscoa de ninho com recheio cremoso de Nutella.',
    details: 'Peso: 250g • Valor: R$ 89,00.',
    weight: '250g',
    price: 89,
    image: '/images/cardapio-de-pascoa/ninho-com-nutela.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'ninho-pascoa',
    name: 'Ninho',
    shortDescription: 'Ovo de Páscoa sabor ninho.',
    details: 'Peso: 250g • Valor: R$ 69,00.',
    weight: '250g',
    price: 69,
    image: '/images/cardapio-de-pascoa/ninho.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'brigadeiro-pascoa',
    name: 'Brigadeiro',
    shortDescription: 'Ovo de Páscoa recheado com brigadeiro.',
    details: 'Peso: 250g • Valor: R$ 69,00.',
    weight: '250g',
    price: 69,
    image: '/images/cardapio-de-pascoa/brigadeiro.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'ferrero-rocher-pascoa',
    name: 'Ferrero Rocher',
    shortDescription: 'Ovo de Páscoa inspirado no sabor Ferrero Rocher.',
    details: 'Peso: 250g • Valor: R$ 95,00.',
    weight: '250g',
    price: 95,
    image: '/images/cardapio-de-pascoa/ferreiro-rocher.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'prestigio-pascoa',
    name: 'Prestígio',
    shortDescription: 'Ovo de Páscoa com recheio de coco e chocolate.',
    details: 'Peso: 250g • Valor: R$ 69,00.',
    weight: '250g',
    price: 69,
    image: '/images/cardapio-de-pascoa/prestigio.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'matilda-pascoa',
    name: 'Matilda',
    shortDescription: 'Ovo de Páscoa sabor Matilda.',
    details: 'Peso: 250g • Valor: R$ 67,00.',
    weight: '250g',
    price: 67,
    image: '/images/cardapio-de-pascoa/matilda.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'mms-pascoa',
    name: 'M&Ms',
    shortDescription: 'Ovo de Páscoa com cobertura e confeitos M&Ms.',
    details: 'Peso: 250g • Valor: R$ 69,00.',
    weight: '250g',
    price: 69,
    image: '/images/cardapio-de-pascoa/m&m.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'guloseimas-pascoa',
    name: 'Guloseimas',
    shortDescription: 'Ovo de Páscoa com mix de guloseimas.',
    details: 'Peso: 250g • Valor: R$ 79,00.',
    weight: '250g',
    price: 79,
    image: '/images/cardapio-de-pascoa/guloseimas.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'trufado-ninho-com-nutella',
    name: 'Trufado ninho com Nutella',
    shortDescription: 'Ovo trufado sabor ninho com Nutella.',
    details: 'Peso: 150g • Valor: R$ 37,00.',
    weight: '150g',
    price: 37,
    image: '/images/cardapio-de-pascoa/trufado-ninho-com-nutela-mouse-maracuja-brigadeiro.jpeg',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'trufado-brigadeiro',
    name: 'Trufado brigadeiro',
    shortDescription: 'Ovo trufado recheado com brigadeiro.',
    details: 'Peso: 150g • Valor: R$ 34,00.',
    weight: '150g',
    price: 34,
    image:
      '/images/cardapio-de-pascoa/trufado-ninho-com-nutela-mouse-maracuja-brigadeiro.jpeg?versao=brigadeiro',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'trufado-mousse-maracuja-fruta',
    name: 'Trufado de mousse de maracujá (fruta)',
    shortDescription: 'Ovo trufado sabor mousse de maracujá (fruta).',
    details: 'Peso: 150g • Valor: R$ 30,00.',
    weight: '150g',
    price: 30,
    image:
      '/images/cardapio-de-pascoa/trufado-ninho-com-nutela-mouse-maracuja-brigadeiro.jpeg?versao=maracuja',
    rating: 5,
    reviewCount: 0,
  },
  {
    id: 'petisqueira-4-sabores',
    name: 'Petisqueira 4 sabores',
    shortDescription: 'Petisqueira com 4 sabores (limitada).',
    details: 'Edição limitada • Valor: R$ 39,99.',
    weight: 'Limitado',
    price: 39.99,
    image: '/images/cardapio-de-pascoa/petisqueira.jpeg',
    rating: 5,
    reviewCount: 0,
  },
];

export const updatesCatalog = [
  {
    id: 'bar-de-brigadeiro',
    category: 'lancamento',
    dateLabel: 'Lançamento',
    title: 'Novidade chegando: Bar de Brigadeiro',
    imageUrl: '/images/novidades/bar-de-brigadeiro.jpeg',
    imageAlt: 'Bar de brigadeiro da Carliz Doces',
    mediaDescription: 'Novo formato para servir brigadeiros em eventos e comemorações.',
    description: 'Conheça o bar de brigadeiro e surpreenda seus convidados com sabores artesanais.',
    status: 'Disponível sob consulta.',
  },
  {
    id: 'brigadeiros',
    category: 'comunicado',
    dateLabel: 'Comunicado',
    title: 'Faça sua encomenda de Brigadeiros!',
    imageUrl: '/images/novidades/brigadeiros.jpeg',
    imageAlt: 'Brigadeiros da Carliz Doces',
    mediaDescription: 'Comunicado oficial sobre encomendas e disponibilidade de brigadeiros.',
    description: 'Entre em contato para confirmar sabores disponíveis e prazos de produção.',
    status: 'Atendimento via WhatsApp.',
  },
  {
    id: 'sorteio-ovo-pascoa',
    category: 'sorteio',
    dateLabel: 'Sorteio',
    title: 'Sorteio de ovo de Páscoa',
    imageUrl: '/images/novidades/sorteio-ovo-pascoa.jpeg',
    imageAlt: 'Sorteio de ovo de Páscoa da Carliz Doces',
    mediaDescription: 'Participe do sorteio acompanhando os canais oficiais da Carliz Doces.',
    description:
      'Confira as regras do sorteio e participe para concorrer a um ovo de Páscoa especial.',
    status: 'Veja o regulamento nas redes sociais.',
  },
];
